import React from "react"
import {
	Collapse, Form, Input, Button, DatePicker, Row, Col
}from "antd"
import moment from "moment"
import locale from "antd/lib/date-picker/locale/ru_RU"
import {
	useSelector
}from "react-redux"
import i18n from "./localization"
import i18nGlobal from "../../../localization"
import "antd/lib/collapse/style/index.css"
import "antd/lib/date-picker/style/index.css"

import localeRu from 'antd/es/date-picker/locale/ru_RU'
import localeBy from 'antd/es/date-picker/locale/by_BY'

import {
	CustomInput
}from "../../../components/CustomInput"
import CustomButton from "../../../components/ButtonCustom"

const { RangePicker } = DatePicker
const rangeConfig = {
	rules: [
		{
			type: 'array'
		}
	]
}

const UsersSearch = (props) => {
	const [form] = Form.useForm()
	const { onFinish, tab } = props
	const isRu = useSelector((state) => state.globalReducer.isRu)

	function disabledStartDate(current){
		const finishDate = form.getFieldValue("finishDate")
		let res = null
		if (finishDate !== undefined)
			res = current && current > moment(finishDate).endOf("day")

		return res
	}

	function disabledFinishDate(current){
		const startDate = form.getFieldValue("startDate")
		let res = null
		if (startDate !== undefined){
			res =
        current &&
        current <
          moment(startDate)
          	.endOf("day")
          	.add(-1, "days")
		}
		return res
	}

	return (
		<>

			<Form
				form={ form }
				labelAlign="left"
				labelCol={ {
					span: 8
				} }
				layout="horizontal"
				name=""
				wrapperCol={ {
					span: 16
				} }
				onFinish={ onFinish }
			>
				<Row>
					<Col span={ 11 }>
						<Form.Item
							label={ i18n.positionName[isRu] }
							name="positionName"
						>
							<CustomInput placeholder={ i18n.positionName[isRu] } />
						</Form.Item>
					</Col>
					<Col
						offset={ 1 }
						span={ 11 }
					>
						<Form.Item
							label={ i18nGlobal.lastName[isRu] }
							name="lastName"
						>
							<CustomInput placeholder={ i18nGlobal.lastName[isRu] } />
						</Form.Item>
					</Col>
					<Col span={ 11 }>
						<Form.Item
							label={ i18nGlobal.firstName[isRu] }
							name="firstName"
						>
							<CustomInput placeholder={ i18nGlobal.firstName[isRu] } />
						</Form.Item>
					</Col>
					<Col
						offset={ 1 }
						span={ 11 }
					>
						<Form.Item
							label={ i18nGlobal.middleName[isRu] }
							name="middleName"
						>
							<CustomInput placeholder={ i18nGlobal.middleName[isRu] } />
						</Form.Item>
					</Col>

					<Col span={ 18 }>
						<Form.Item
							label={ i18n.registrationDate[isRu] }
							name="regDate"
							{ ...rangeConfig }
						>
							<RangePicker
								allowEmpty={ [true, true] }
								format="DD.MM.YYYY"
								locale={ isRu ? localeRu : localeBy }
							/>
						</Form.Item>
						{ /* <Form.Item
							label={ i18n.registrationDateFrom[isRu] }
							name="startDate"
						>
							<DatePicker
								disabledDate={ disabledStartDate }
								format="DD.MM.YYYY"
								locale={ locale }
								placeholder={ i18nGlobal.chooseDate[isRu] }
							/>
						</Form.Item>

						<Form.Item
							label={ i18n.registrationDateTo[isRu] }
							name="finishDate"
						>
							<DatePicker
								disabledDate={ disabledFinishDate }
								format="DD.MM.YYYY"
								locale={ locale }
								placeholder={ i18nGlobal.chooseDate[isRu] }
							/>
						</Form.Item> */ }
					</Col>
					<Col
						offset={ 8 }
						span={ 7 }
					>
						<Form.Item
							wrapperCol={ {
								span: 24
							} }
						>
							<CustomButton
								size="small"
								type="grey"
								onClick={ () => {
									form.resetFields()
									onFinish(form.getFieldsValue())
								} }
							>
								{ i18nGlobal.clean[isRu] }
							</CustomButton>
						</Form.Item>
					</Col>
					<Col
						offset={ 1 }
						span={ 7 }
					>
						<Form.Item
							wrapperCol={ {
								span: 24
							} }
						>
							<CustomButton
								htmlType="submit"
								size="small"
								type="orange"
							>
								{ i18nGlobal.find[isRu] }
							</CustomButton>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</>
	)
}

export default UsersSearch
